<template>
  <div id="tabs" class="tabs bgStyle" :class="{ 'd-none': isKeyBoardOpen, daskboard: isDashboardView() }">
    <div
      v-if="displayHomeButton()"
      v-tooltip="{ title: setRouterLinkLabel() }"
      class="tabs__item home"
      :key="setRouterLinkLabel()"
    >
      <router-link :to="{ name: setRouterLinkPath() }" class="tabs__link">
        <FontAwesomeIcon :icon="'fa-light fa-' + setStudeaManagerHomeIcon()" />
        <div class="tabs__label">{{ $t(setRouterLinkLabel()) }}</div>
      </router-link>
    </div>
    <template v-if="triad && triad.menu && displayMenu()">
      <template v-for="item in triad.menu" :key="item.id">
        <div v-if="moduleIsAvailable(item)" v-tooltip="{ title: item.title }" class="tabs__item position-relative">
          <router-link :to="{ name: item.code }" class="tabs__link">
            <FontAwesomeIcon :icon="'fa-light fa-' + item.icon" />
          </router-link>
          <div class="tabs__label">{{ item.title }}</div>
          <div v-if="item.code === 'MODULE_STUDEA_MESSAGE' && user.userNewMessage > 0" class="notification">
            {{ user.userNewMessage }}
          </div>
        </div>
      </template>
    </template>
    <div
      v-if="displayRegistrationButton()"
      v-module="{ code: moduleConstantes.MODULE_STUDEA_REGISTRATION }"
      class="tabs__item home"
    >
      <router-link
        v-access:[permissions]="{
          access: accessManager().ALL,
          code: studeaManagerManager().STUDEA_MANAGER_REGISTRATION,
        }"
        :to="{ name: 'RegistrationDashboard' }"
        class="tabs__link"
      >
        <FontAwesomeIcon class="triadTab__icon" icon="fa-light fa-users-gear" />
        <div class="tabs__label">{{ $t("dashboard.registration") }}</div>
      </router-link>
    </div>
    <div v-if="displayTrainingListButton()" class="tabs__item home">
      <router-link :to="{ name: 'TrainingList' }" class="tabs__link">
        <FontAwesomeIcon class="triadTab__icon" icon="fa-light fa-screen-users" />
        <div class="tabs__label">{{ $t("global.label.trainings") }}</div>
      </router-link>
    </div>
    <div v-if="displayHandleMenuButton()" v-tooltip="{ title: $t('menu') }" class="tabs__item burger" @click="openMenu">
      <div class="tabs__link">
        <FontAwesomeIcon icon="fa-light fa-bars" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "pinia";
import { useTriadStore } from "@/store/triad/triad";
import { useUserStore } from "@/store/user/user";
import { useMainStore } from "@/store/main/main";
import { moduleManager } from "@/services/module/module-manager";
import { registrationConstante } from "@/constantes/registration";
import { moduleConstantes } from "@/constantes/module";
import { accessManager } from "@/services/security/access-manager";
import { studeaManagerManager } from "@/services/studea-manager/studea-manager-manager";
import { tabsManager } from "@/services/utilities/tabs-manager";
import { useTrainingCourseStore } from "@/store/training-course/training-course";

export default {
  name: "TabsComponent",
  data() {
    return {
      isKeyBoardOpen: false,
    };
  },
  computed: {
    moduleConstantes() {
      return moduleConstantes;
    },
    ...mapState(useTriadStore, {
      triad: (store) => store.triad,
    }),
    ...mapState(useTriadStore, {
      triad: (store) => store.triad,
    }),
    ...mapState(useTrainingCourseStore, {
      trainingCourse: (store) => store.trainingCourse,
    }),
    ...mapState(useUserStore, {
      user: (store) => store.user,
    }),

    isApprenticeOrCompany() {
      return (
        this.user &&
        this.user?.target === "registration" &&
        (this.actorType === registrationConstante.REGISTRATION_ACTOR_APPRENTICE ||
          this.actorType === registrationConstante.REGISTRATION_ACTOR_COMPANY)
      );
    },
  },
  mounted() {
    if (window.innerWidth < 768) {
      window.addEventListener("resize", this.checkKeyBoardOpen);
    }
  },
  unmounted() {
    if (window.innerWidth < 768) {
      window.removeEventListener("resize", this.checkKeyBoardOpen);
    }
  },
  methods: {
    studeaManagerManager() {
      return studeaManagerManager;
    },
    accessManager() {
      return accessManager;
    },
    openMenu() {
      if (this.isStudeaManagerPage() || tabsManager.isRegistration(this.$route)) {
        this.openSideBar();
      } else {
        const menu = document.getElementById("menu");
        if (menu) {
          menu.classList.add("show");
        }
      }
    },

    moduleIsAvailable(item) {
      return moduleManager.moduleIsAvailable(item);
    },

    setRouterLinkPath() {
      if (this.user?.target === "registration") {
        this.setRegistrationActorHomePath();
      }

      if (
        (this.$route.name === "Dashboard" ||
          tabsManager.isStudeaManagerArea(this.$route) ||
          tabsManager.isRegistration(this.$route) ||
          tabsManager.isStudeaManagerTraining(this.$route)) &&
        this.isTrainingRouterLinkPath()
      ) {
        return "TrainingCourseList";
      } else {
        return "Dashboard";
      }
    },

    setRegistrationActorHomePath() {
      switch (this.user.tragetParams?.registrationActorType) {
        default:
        case registrationConstante.REGISTRATION_ACTOR_APPRENTICE:
          return "ApprenticeContractList";
        case registrationConstante.REGISTRATION_ACTOR_COMPANY:
          return "CompanyContractList";
        case registrationConstante.REGISTRATION_ACTOR_UFA:
          return "TrainingList";
      }
    },

    displayMenu() {
      return this.$router.currentRoute.value.name !== "TrainingCourseList";
    },

    displayRegistrationButton() {
      return tabsManager.displayRegistrationButton(this.$route, null, this.isApprenticeOrCompany);
    },

    displayTrainingListButton() {
      return tabsManager.displayTrainingListButton(this.$route, null, this.isApprenticeOrCompany, this.user);
    },

    displayHandleMenuButton() {
      return tabsManager.displayHandleMenuButton(this.$router);
    },

    setRouterLinkLabel() {
      if (this.$route.name === "Dashboard" && this.isTrainingRouterLinkPath()) {
        return this.$tc("studea_manager.trainingCourse.title", 2);
      } else {
        return this.$t("page.home");
      }
    },

    setStudeaManagerHomeIcon() {
      if (this.$route.name === "Dashboard" && this.isTrainingRouterLinkPath()) {
        return "graduation-cap";
      } else {
        return "house";
      }
    },

    isTrainingRouterLinkPath() {
      return this.user && this.user.target !== "triad";
    },

    isStudeaManagerPage() {
      return this.$router.currentRoute.value.matched.find((item) => item.name === "studeaManagerLayout");
    },

    checkKeyBoardOpen() {
      this.isKeyBoardOpen = window.innerHeight < window.screen.height * 0.7;
    },

    isDashboardView() {
      return (
        this.$router.currentRoute.value.matched.find((item) => item.name === "DashboardLayout") &&
        !this.$router.currentRoute.value.matched.find((item) => item.name === "TrainingCourseList")
      );
    },

    displayHomeButton() {
      return !tabsManager.isTrainingCourseList(this.$route);
    },

    ...mapActions(useMainStore, { openSideBar: "openSideBar" }),
  },
};
</script>

<style lang="scss" scoped>
.tabs {
  position: fixed;
  left: 50%;
  bottom: 35px;
  transform: translateX(-50%);
  max-width: 750px;
  width: auto;
  display: none;
  box-shadow: rgba(0, 0, 0, 0.35) 0 5px 15px;
  z-index: 1000;
  border-radius: $radius;
  padding: 10px;
  background: var(--primary-color);

  &.daskboard {
    display: flex;
  }

  @include up-to-md {
    display: flex;
    bottom: 0;
    left: 0;
    right: 0;
    transform: none;
    justify-content: space-between;
    background: var(--primary-color);
    border-radius: 0;
    padding: 10px 0;
  }

  @include dark-theme {
    background: $m-color-10;
    box-shadow: inset 1px 1px 1px 1px rgba(255, 255, 255, 0.5);
  }

  &__label {
    color: $white;
    font-size: 12px;
    text-align: center;
    white-space: nowrap;
    display: none;

    @include up-to-md {
      display: block;
    }
  }

  &__link {
    @include up-to-md {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 0 10px;
    }
  }

  &__item {
    text-align: center;
    width: 50px;
    height: 50px;
    margin: 0 5px;

    &.burger,
    &.account {
      display: none;
      cursor: pointer;
    }

    @include up-to-md {
      display: none;
      width: 25%;
      height: 40px;

      &.burger,
      &.account,
      &.home {
        display: block;
      }
    }

    a,
    div.tabs__link {
      display: flex;
      width: 100%;
      height: 100%;
      justify-content: center;
      align-items: center;
      font-size: 30px;
      color: $white;

      @include up-to-md {
        font-size: 25px;
      }

      &.router-link-active {
        background: $white;
        border-radius: 50%;

        @include dark-theme {
          background: $white;
          color: $blue;
        }

        @include up-to-md {
          background: none;
        }
      }
    }
  }

  .home {
    svg {
      color: $white;
    }

    .router-link-active {
      svg {
        color: var(--primary-color);

        @include up-to-lg {
          color: $white;
        }
      }
    }
  }

  .notification {
    position: absolute;
    top: -5px;
    padding: 0 6px;
    border-radius: 5px;
    right: -2px;
    background-color: $green;
    z-index: 5;
    color: $white;
  }
}
</style>
